class ZvCollectionGrid extends HTMLElement {
  constructor() {
    super();
    this.onFilterOpen = this.onFilterOpen.bind(this);
    this.onFilterClose = this.onFilterClose.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onViewToggle = this.onViewToggle.bind(this);
  }

  connectedCallback() {
    this.bindUi();
    this.restoreColumnPreference();
    this.patchFacetFiltersForm();
  }

  disconnectedCallback() {
    this.unbindUi();
  }

  bindUi() {
    this.unbindUi();

    this.grid = this.querySelector('.col-grid');
    this.filters = this.querySelector('.filters');
    this.overlay = this.querySelector('.filters-overlay');
    this.filterBtn = this.querySelector('.zv-filter-btn');
    this.closeBtns = this.querySelectorAll('.zv-filters-close, .filters-close');
    this.viewToggle = this.querySelector('.view-toggle');

    this.filterBtn?.addEventListener('click', this.onFilterOpen);
    this.closeBtns?.forEach((btn) => btn.addEventListener('click', this.onFilterClose));
    this.overlay?.addEventListener('click', this.onOverlayClick);
    this.viewToggle?.addEventListener('click', this.onViewToggle);
  }

  unbindUi() {
    this.filterBtn?.removeEventListener('click', this.onFilterOpen);
    this.closeBtns?.forEach((btn) => btn.removeEventListener('click', this.onFilterClose));
    this.overlay?.removeEventListener('click', this.onOverlayClick);
    this.viewToggle?.removeEventListener('click', this.onViewToggle);
  }

  rebind() {
    this.bindUi();
    this.restoreColumnPreference();
  }

  patchFacetFiltersForm() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__zvPatched) return;

    const originalRenderAdditional = FacetFiltersForm.renderAdditionalElements;
    FacetFiltersForm.renderAdditionalElements = function (html) {
      if (originalRenderAdditional) {
        try {
          originalRenderAdditional(html);
        } catch (error) {
          /* ZV uses custom mobile drawer — Dawn menu-drawer may be absent */
        }
      }
    };

    const originalRenderProductCount = FacetFiltersForm.renderProductCount;
    FacetFiltersForm.renderProductCount = function (html) {
      if (originalRenderProductCount) {
        try {
          originalRenderProductCount(html);
        } catch (error) {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const countEl = parsed.getElementById('ProductCount');
          const container = document.getElementById('ProductCount');
          const containerDesktop = document.getElementById('ProductCountDesktop');

          if (countEl && container) {
            container.innerHTML = countEl.innerHTML;
            container.closest('.product-count')?.classList.remove('loading');
          }
          if (countEl && containerDesktop) {
            containerDesktop.innerHTML = countEl.innerHTML;
          }
        }
      }

      document
        .querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner')
        .forEach((spinner) => spinner.classList.add('hidden'));

      document.dispatchEvent(new CustomEvent('zv:collection:updated'));
    };

    const originalRenderGrid = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      originalRenderGrid(html);
      document.dispatchEvent(new CustomEvent('zv:collection:updated'));
    };

    FacetFiltersForm.__zvPatched = true;
  }

  onFilterOpen() {
    this.filters?.classList.add('show');
    this.overlay?.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  onFilterClose() {
    this.filters?.classList.remove('show');
    this.overlay?.classList.remove('show');
    document.body.style.overflow = '';
  }

  onOverlayClick() {
    this.onFilterClose();
  }

  onViewToggle(event) {
    const button = event.target.closest('button[data-cols]');
    if (!button || !this.grid) return;

    const cols = button.getAttribute('data-cols');
    this.grid.setAttribute('data-cols', cols);
    this.viewToggle?.querySelectorAll('button').forEach((btn) => {
      btn.classList.toggle('active', btn.getAttribute('data-cols') === cols);
    });

    try {
      localStorage.setItem('zv-collection-cols', cols);
    } catch (error) {
      /* ignore */
    }
  }

  restoreColumnPreference() {
    if (!this.grid || !this.viewToggle) return;

    let cols = this.grid.getAttribute('data-cols') || this.viewToggle.dataset.defaultCols || '3';
    try {
      cols = localStorage.getItem('zv-collection-cols') || cols;
    } catch (error) {
      /* ignore */
    }

    this.grid.setAttribute('data-cols', cols);
    this.viewToggle.querySelectorAll('button').forEach((btn) => {
      btn.classList.toggle('active', btn.getAttribute('data-cols') === cols);
    });
  }
}

if (!customElements.get('zv-collection-grid')) {
  customElements.define('zv-collection-grid', ZvCollectionGrid);
}

document.addEventListener('zv:collection:updated', () => {
  document.querySelectorAll('zv-collection-grid').forEach((grid) => {
    grid.rebind();
  });
});
